const formatDate = (dateObj: Date) => {

    let newDate = dateObj.toLocaleDateString('en-CA')

    return newDate.toString()
}

export {
    formatDate
}